// ===== SITE TAKEOFF CONSTANTS =====

// Feature flag — set to false to disable expanded area types
export const ENABLE_EXPANDED_AREA_TYPES = true;

// ===== AREA TYPES =====

export const AREA_TYPES = {
  // Hardscape
  HS_SIDEWALK: 'hs_sidewalk',
  HS_PLAZA: 'hs_plaza',
  HS_DUMPSTER_PAD: 'hs_dumpster_pad',
  PV_WALKWAYS: 'pv_walkways',
  AS_PARKING: 'as_parking',
  BUILDING: 'building',
  // Gravel / Desert
  GR_CLEAN: 'gr_clean',
  GR_DESERT_LOW: 'gr_desert_low',
  GR_DESERT_MED: 'gr_desert_med',
  GR_DESERT_HIGH: 'gr_desert_high',
  GR_RIPRAP: 'gr_riprap',
  // Beds / Planters
  BD_SHRUB_LOW: 'bd_shrub_low',
  BD_SHRUB_MED: 'bd_shrub_med',
  BD_SHRUB_HIGH: 'bd_shrub_high',
  BD_FLOWER_COLOR: 'bd_flower_color',
  // Turf
  NT_TURF_OPEN: 'nt_turf_open',
  NT_TURF_OBSTRUCTED: 'nt_turf_obstructed',
  ST_SYNTHETIC: 'st_synthetic',
  // Other Landscape
  GC_GROUNDCOVER: 'gc_groundcover',
  DR_RETENTION: 'dr_retention',
  DR_BAREGROUND: 'dr_bareground',
  // Exclusions
  DO_NOT_SPRAY: 'do_not_spray',
  DO_NOT_SERVICE: 'do_not_service',
  // Trails
  TR_NATURAL: 'tr_natural',
  TR_DG: 'tr_dg',
  // Tree Disposition
  TREE_SALVAGE: 'tree_salvage',
  TREE_REMAIN: 'tree_remain',
  TREE_REMOVE: 'tree_remove',
  // Generic Markers
  POINT_MARKER: 'point_marker',
  ELLIPSE_ZONE: 'ellipse_zone',
};

// ===== LABELS =====

export const AREA_TYPE_LABELS = {
  [AREA_TYPES.HS_SIDEWALK]: 'Sidewalk / Pedestrian Paths',
  [AREA_TYPES.HS_PLAZA]: 'Plaza / Courtyard / Breezeway',
  [AREA_TYPES.HS_DUMPSTER_PAD]: 'Dumpster Pad / Enclosure',
  [AREA_TYPES.PV_WALKWAYS]: 'Paver Walkways / Plazas',
  [AREA_TYPES.AS_PARKING]: 'Parking / Drive Lanes',
  [AREA_TYPES.BUILDING]: 'Building Footprint',
  [AREA_TYPES.GR_CLEAN]: 'Gravel / DG — Open',
  [AREA_TYPES.GR_DESERT_LOW]: 'Desert Planting — Low',
  [AREA_TYPES.GR_DESERT_MED]: 'Desert Planting — Med',
  [AREA_TYPES.GR_DESERT_HIGH]: 'Desert Planting — High',
  [AREA_TYPES.GR_RIPRAP]: 'Rip-Rap / Cobble / Boulder',
  [AREA_TYPES.BD_SHRUB_LOW]: 'Shrub Bed — Low',
  [AREA_TYPES.BD_SHRUB_MED]: 'Shrub Bed — Med',
  [AREA_TYPES.BD_SHRUB_HIGH]: 'Shrub Bed — High',
  [AREA_TYPES.BD_FLOWER_COLOR]: 'Seasonal Color / Annuals',
  [AREA_TYPES.NT_TURF_OPEN]: 'Natural Turf — Open',
  [AREA_TYPES.NT_TURF_OBSTRUCTED]: 'Natural Turf — Obstructed',
  [AREA_TYPES.ST_SYNTHETIC]: 'Synthetic Turf',
  [AREA_TYPES.GC_GROUNDCOVER]: 'Living Groundcover',
  [AREA_TYPES.DR_RETENTION]: 'Retention Basin',
  [AREA_TYPES.DR_BAREGROUND]: 'Bare Ground',  
  [AREA_TYPES.DO_NOT_SPRAY]: 'DO NOT SPRAY',
  [AREA_TYPES.DO_NOT_SERVICE]: 'DO NOT SERVICE',
  [AREA_TYPES.TR_NATURAL]: 'Natural Trail',
  [AREA_TYPES.TR_DG]: 'DG Trail',
  // Tree Disposition
  [AREA_TYPES.TREE_SALVAGE]: 'Tree — Salvage',
  [AREA_TYPES.TREE_REMAIN]: 'Tree — Remain in Place',
  [AREA_TYPES.TREE_REMOVE]: 'Tree — Remove',
  // Generic Markers
  [AREA_TYPES.POINT_MARKER]: 'Point Marker',
  [AREA_TYPES.ELLIPSE_ZONE]: 'Ellipse Zone',
};

// ===== COLORS =====

export const AREA_TYPE_COLORS = {
  // Hardscape — grays
  [AREA_TYPES.HS_SIDEWALK]: '#C0C0C0',
  [AREA_TYPES.HS_PLAZA]: '#A9A9A9',
  [AREA_TYPES.HS_DUMPSTER_PAD]: '#778899',
  [AREA_TYPES.PV_WALKWAYS]: '#D2691E',
  [AREA_TYPES.AS_PARKING]: '#808080',
  [AREA_TYPES.BUILDING]: '#696969',
  // Gravel / Desert — tans
  [AREA_TYPES.GR_CLEAN]: '#DEB887',
  [AREA_TYPES.GR_DESERT_LOW]: '#F4A460',
  [AREA_TYPES.GR_DESERT_MED]: '#DAA520',
  [AREA_TYPES.GR_DESERT_HIGH]: '#B8860B',
  [AREA_TYPES.GR_RIPRAP]: '#8B7355',
  // Beds / Planters — greens/yellows
  [AREA_TYPES.BD_SHRUB_LOW]: '#9ACD32',
  [AREA_TYPES.BD_SHRUB_MED]: '#6B8E23',
  [AREA_TYPES.BD_SHRUB_HIGH]: '#556B2F',
  [AREA_TYPES.BD_FLOWER_COLOR]: '#FF69B4',
  // Turf — greens
  [AREA_TYPES.NT_TURF_OPEN]: '#228B22',
  [AREA_TYPES.NT_TURF_OBSTRUCTED]: '#2E8B57',
  [AREA_TYPES.ST_SYNTHETIC]: '#00FA9A',
  // Other landscape
  [AREA_TYPES.GC_GROUNDCOVER]: '#32CD32',
  [AREA_TYPES.DR_RETENTION]: '#4169E1',
  [AREA_TYPES.DR_BAREGROUND]: '#a12a21',
  
  // Exclusions
  [AREA_TYPES.DO_NOT_SPRAY]: '#FF0000',
  [AREA_TYPES.DO_NOT_SERVICE]: '#800080',
  // Trails
  [AREA_TYPES.TR_NATURAL]: '#8B4513',
  [AREA_TYPES.TR_DG]: '#D2B48C',
  // Tree Disposition
  [AREA_TYPES.TREE_SALVAGE]: '#1E90FF',    // blue — relocate/save
  [AREA_TYPES.TREE_REMAIN]: '#228B22',     // green — stays
  [AREA_TYPES.TREE_REMOVE]: '#DC143C',     // red — remove
  // Generic Markers
  [AREA_TYPES.POINT_MARKER]: '#FF8C00',    // orange
  [AREA_TYPES.ELLIPSE_ZONE]: '#9370DB',    // purple
};

// ===== PLANT-BEARING TYPES (show density controls) =====

export const PLANT_BEARING_TYPES = [
  AREA_TYPES.GR_DESERT_LOW,
  AREA_TYPES.GR_DESERT_MED,
  AREA_TYPES.GR_DESERT_HIGH,
  AREA_TYPES.BD_SHRUB_LOW,
  AREA_TYPES.BD_SHRUB_MED,
  AREA_TYPES.BD_SHRUB_HIGH,
  AREA_TYPES.BD_FLOWER_COLOR,
  AREA_TYPES.GC_GROUNDCOVER,
];

// ===== DENSITY OPTIONS =====

export const SHRUB_DENSITY_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'low', label: 'Low (< 30% cover)' },
  { value: 'med', label: 'Med (30-60% cover)' },
  { value: 'high', label: 'High (> 60% cover)' },
];

// ===== MODIFIER OPTIONS =====

export const MODIFIER_DEFS = {
  access: {
    label: 'Access',
    type: 'toggle',
    options: ['open', 'obstructed'],
    default: 'open',
  },
  slope: {
    label: 'Slope',
    type: 'toggle',
    options: ['flat', 'sloped'],
    default: 'flat',
  },
  litterExposure: {
    label: 'Litter Exposure',
    type: 'toggle',
    options: ['low', 'high'],
    default: 'low',
  },
  weedPressure: {
    label: 'Weed Pressure',
    type: 'select',
    options: ['low', 'med', 'high'],
    default: 'low',
  },
  limitedAccess: {
    label: 'Limited Access',
    type: 'checkbox',
    default: false,
  },
  blowRestrictions: {
    label: 'Blow Restrictions',
    type: 'checkbox',
    default: false,
  },
  irrigationIncluded: {
    label: 'Irrigation',
    type: 'select',
    options: ['none', 'basic', 'full'],
    default: 'none',
  },
};

// Default modifier values
export const DEFAULT_MODIFIERS = {
  access: 'open',
  slope: 'flat',
  litterExposure: 'low',
  weedPressure: 'low',
  limitedAccess: false,
  blowRestrictions: false,
  irrigationIncluded: 'none',
};

// Default plant density values
export const DEFAULT_PLANT_DENSITY = {
  treeCount: 0,
  shrubDensity: 'none',
  groundcoverDensity: 'none',
};

// ===== CATEGORY GROUPINGS (for summary view) =====

export const AREA_CATEGORIES = {
  HARDSCAPE: {
    label: 'Hardscape / Structures',
    types: [
      AREA_TYPES.HS_SIDEWALK,
      AREA_TYPES.HS_PLAZA,
      AREA_TYPES.HS_DUMPSTER_PAD,
      AREA_TYPES.PV_WALKWAYS,
      AREA_TYPES.AS_PARKING,
      AREA_TYPES.BUILDING,
      AREA_TYPES.TR_DG,
    ],
  },
  GRAVEL_DESERT: {
    label: 'Gravel / Desert',
    types: [
      AREA_TYPES.GR_CLEAN,
      AREA_TYPES.GR_DESERT_LOW,
      AREA_TYPES.GR_DESERT_MED,
      AREA_TYPES.GR_DESERT_HIGH,
      AREA_TYPES.GR_RIPRAP,
    ],
  },
  BEDS_PLANTERS: {
    label: 'Beds / Planters',
    types: [
      AREA_TYPES.BD_SHRUB_LOW,
      AREA_TYPES.BD_SHRUB_MED,
      AREA_TYPES.BD_SHRUB_HIGH,
      AREA_TYPES.BD_FLOWER_COLOR,
    ],
  },
  TURF: {
    label: 'Turf',
    types: [
      AREA_TYPES.NT_TURF_OPEN,
      AREA_TYPES.NT_TURF_OBSTRUCTED,
      AREA_TYPES.ST_SYNTHETIC,
    ],
  },
  OTHER_LANDSCAPE: {
    label: 'Other Landscape',
    types: [
      AREA_TYPES.GC_GROUNDCOVER,
      AREA_TYPES.DR_RETENTION,
      AREA_TYPES.TR_NATURAL,
      AREA_TYPES.DR_BAREGROUND
    ],
  },
  EXCLUSIONS: {
    label: 'Exclusion Zones',
    types: [
      AREA_TYPES.DO_NOT_SPRAY,
      AREA_TYPES.DO_NOT_SERVICE,
    ],
  },
  TREE_DISPOSITION: {
    label: 'Tree Disposition',
    types: [
      AREA_TYPES.TREE_SALVAGE,
      AREA_TYPES.TREE_REMAIN,
      AREA_TYPES.TREE_REMOVE,
    ],
  },
  MARKERS: {
    label: 'Markers / Zones',
    types: [
      AREA_TYPES.POINT_MARKER,
      AREA_TYPES.ELLIPSE_ZONE,
    ],
  },
};

// Landscape categories (for total landscape SF)
export const LANDSCAPE_CATEGORIES = ['GRAVEL_DESERT', 'BEDS_PLANTERS', 'TURF', 'OTHER_LANDSCAPE'];
export const HARDSCAPE_CATEGORIES = ['HARDSCAPE'];

// ===== SERVICES =====

export const SERVICES = {
  MOWING: 'mowing',
  EDGING: 'edging',
  BLOWING: 'blowing',
  TRIMMING: 'trimming',
  PRUNING: 'pruning',
  WEED_CONTROL: 'weed_control',
  PRE_EMERGENT: 'pre_emergent',
  FERTILIZATION: 'fertilization',
  DEBRIS_REMOVAL: 'debris_removal',
  SWEEPING: 'sweeping',
  TREE_TRIMMING: 'tree_trimming',
  PALM_TRIMMING: 'palm_trimming',
  IRRIGATION_CHECK: 'irrigation_check',
  PLANTING: 'planting',
  DEADHEADING: 'deadheading',
  PEST_CONTROL: 'pest_control',
  LITTER_PICKUP: 'litter_pickup',
};

export const SERVICE_LABELS = {
  [SERVICES.MOWING]: 'Mowing',
  [SERVICES.EDGING]: 'Edging',
  [SERVICES.BLOWING]: 'Blowing',
  [SERVICES.TRIMMING]: 'Trimming / Hedging',
  [SERVICES.PRUNING]: 'Low Pruning (< 8\')',
  [SERVICES.WEED_CONTROL]: 'Weed Control',
  [SERVICES.PRE_EMERGENT]: 'Pre-Emergent',
  [SERVICES.FERTILIZATION]: 'Fertilization',
  [SERVICES.DEBRIS_REMOVAL]: 'Debris Removal',
  [SERVICES.SWEEPING]: 'Sweeping',
  [SERVICES.TREE_TRIMMING]: 'Tree Trimming',
  [SERVICES.PALM_TRIMMING]: 'Palm Trimming',
  [SERVICES.IRRIGATION_CHECK]: 'Irrigation Check',
  [SERVICES.PLANTING]: 'Planting / Rotation',
  [SERVICES.DEADHEADING]: 'Deadheading',
  [SERVICES.PEST_CONTROL]: 'Pest Control',
  [SERVICES.LITTER_PICKUP]: 'Litter Pickup',
};

// Auto-suggested services per area type — user can override
export const DEFAULT_SERVICES_BY_TYPE = {
  // Turf
  [AREA_TYPES.NT_TURF_OPEN]: [SERVICES.MOWING, SERVICES.EDGING, SERVICES.BLOWING, SERVICES.FERTILIZATION, SERVICES.WEED_CONTROL],
  [AREA_TYPES.NT_TURF_OBSTRUCTED]: [SERVICES.MOWING, SERVICES.EDGING, SERVICES.BLOWING, SERVICES.TRIMMING, SERVICES.FERTILIZATION, SERVICES.WEED_CONTROL],
  [AREA_TYPES.ST_SYNTHETIC]: [SERVICES.BLOWING, SERVICES.DEBRIS_REMOVAL],
  // Gravel / Desert
  [AREA_TYPES.GR_CLEAN]: [SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.BLOWING, SERVICES.DEBRIS_REMOVAL],
  [AREA_TYPES.GR_DESERT_LOW]: [SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.BLOWING, SERVICES.PRUNING, SERVICES.DEBRIS_REMOVAL],
  [AREA_TYPES.GR_DESERT_MED]: [SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.BLOWING, SERVICES.PRUNING, SERVICES.DEBRIS_REMOVAL],
  [AREA_TYPES.GR_DESERT_HIGH]: [SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.BLOWING, SERVICES.PRUNING, SERVICES.DEBRIS_REMOVAL, SERVICES.TRIMMING],
  [AREA_TYPES.GR_RIPRAP]: [SERVICES.WEED_CONTROL, SERVICES.DEBRIS_REMOVAL],
  // Beds / Planters
  [AREA_TYPES.BD_SHRUB_LOW]: [SERVICES.PRUNING, SERVICES.WEED_CONTROL, SERVICES.BLOWING, SERVICES.FERTILIZATION],
  [AREA_TYPES.BD_SHRUB_MED]: [SERVICES.PRUNING, SERVICES.TRIMMING, SERVICES.WEED_CONTROL, SERVICES.BLOWING, SERVICES.FERTILIZATION],
  [AREA_TYPES.BD_SHRUB_HIGH]: [SERVICES.PRUNING, SERVICES.TRIMMING, SERVICES.WEED_CONTROL, SERVICES.BLOWING, SERVICES.FERTILIZATION, SERVICES.DEBRIS_REMOVAL],
  [AREA_TYPES.BD_FLOWER_COLOR]: [SERVICES.PLANTING, SERVICES.DEADHEADING, SERVICES.WEED_CONTROL, SERVICES.FERTILIZATION, SERVICES.BLOWING],
  // Other Landscape
  [AREA_TYPES.GC_GROUNDCOVER]: [SERVICES.TRIMMING, SERVICES.WEED_CONTROL, SERVICES.BLOWING, SERVICES.FERTILIZATION],
  [AREA_TYPES.DR_RETENTION]: [SERVICES.WEED_CONTROL, SERVICES.DEBRIS_REMOVAL, SERVICES.BLOWING, , SERVICES.PRE_EMERGENT],
  [AREA_TYPES.DR_BAREGROUND]: [SERVICES.WEED_CONTROL, SERVICES.DEBRIS_REMOVAL, SERVICES.BLOWING, SERVICES.PRE_EMERGENT],
  // Hardscape
  [AREA_TYPES.HS_SIDEWALK]: [SERVICES.BLOWING, SERVICES.SWEEPING, SERVICES.LITTER_PICKUP],
  [AREA_TYPES.HS_PLAZA]: [SERVICES.BLOWING, SERVICES.SWEEPING, SERVICES.LITTER_PICKUP],
  [AREA_TYPES.HS_DUMPSTER_PAD]: [SERVICES.BLOWING, SERVICES.SWEEPING, SERVICES.LITTER_PICKUP, SERVICES.DEBRIS_REMOVAL],
  [AREA_TYPES.PV_WALKWAYS]: [SERVICES.BLOWING, SERVICES.WEED_CONTROL, SERVICES.SWEEPING],
  [AREA_TYPES.AS_PARKING]: [SERVICES.BLOWING, SERVICES.SWEEPING, SERVICES.LITTER_PICKUP],
  [AREA_TYPES.BUILDING]: [],
  // Exclusions
  [AREA_TYPES.DO_NOT_SPRAY]: [],
  [AREA_TYPES.DO_NOT_SERVICE]: [],
  // Trails
  [AREA_TYPES.TR_NATURAL]: [SERVICES.WEED_CONTROL, SERVICES.DEBRIS_REMOVAL, SERVICES.BLOWING],
  [AREA_TYPES.TR_DG]: [SERVICES.BLOWING, SERVICES.WEED_CONTROL, SERVICES.EDGING, SERVICES.DEBRIS_REMOVAL],
  // Tree Disposition
  [AREA_TYPES.TREE_SALVAGE]: [SERVICES.TREE_TRIMMING],
  [AREA_TYPES.TREE_REMAIN]: [SERVICES.TREE_TRIMMING, SERVICES.PRUNING],
  [AREA_TYPES.TREE_REMOVE]: [],
  // Generic Markers
  [AREA_TYPES.POINT_MARKER]: [],
  [AREA_TYPES.ELLIPSE_ZONE]: [],
};

// Get suggested services for an area type
export const getSuggestedServices = (areaType) => {
  const resolved = resolveAreaType(areaType);
  return DEFAULT_SERVICES_BY_TYPE[resolved] || [];
};

// ===== LEGACY TYPE MAPPING =====
// Maps old area types to new equivalents for display
export const LEGACY_TYPE_MAP = {
  turf: AREA_TYPES.NT_TURF_OPEN,
  ornamental: AREA_TYPES.BD_SHRUB_MED,
  bare_ground: AREA_TYPES.GR_CLEAN,
};

// Resolve an areaType (handles legacy values)
export const resolveAreaType = (areaType) => {
  if (!areaType) return AREA_TYPES.GR_CLEAN;
  if (AREA_TYPE_LABELS[areaType]) return areaType;
  if (LEGACY_TYPE_MAP[areaType]) return LEGACY_TYPE_MAP[areaType];
  return areaType;
};

// ===== PRODUCTION RATES (labor calc defaults) =====

// visitsPerYear: how many times/year this service is performed.
// The calculator divides hours by (visitsPerYear / totalVisitsPerYear) to get per-visit cost.
// Default totalVisitsPerYear = 42 (weekly visits ~10 months in AZ).
export const DEFAULT_VISITS_PER_YEAR = 42;

// Labor categories — different billing rates
export const LABOR_CATEGORIES = {
  mtc:        { label: 'Maintenance (General)', color: '#1565c0' },
  arborist:   { label: 'Arborist', color: '#5d4037' },
  herbicide:  { label: 'Herbicide Tech', color: '#e65100' },
  irrigation: { label: 'Irrigation Tech', color: '#2e7d32' },
};

// Rates are PER MANHOUR — what one person can cover in one hour.
// For desert commercial: crews walk fast, spray weeds, minimal mowing.
export const DEFAULT_PRODUCTION_RATES = {
  // ── Maintenance crew ──
  mowing:          { rate: 40000, unit: 'sf_hr',    visitsPerYear: 42, coveragePerVisit: 1.0, category: 'mtc', label: 'Mowing' },
  edging:          { rate: 5000,  unit: 'lf_hr',    visitsPerYear: 42, coveragePerVisit: 1.0, category: 'mtc', label: 'Edging' },
  blowing:         { rate: 80000, unit: 'sf_hr',    visitsPerYear: 42, coveragePerVisit: 1.0, category: 'mtc', label: 'Blowing' },
  weed_control:    { rate: 45000, unit: 'sf_hr',    visitsPerYear: 42, coveragePerVisit: 1.0, category: 'mtc', label: 'Weed Control' },
  debris_removal:  { rate: 65000, unit: 'sf_hr',    visitsPerYear: 42, coveragePerVisit: 1.0, category: 'mtc', label: 'Debris Removal' },
  litter_pickup:   { rate: 65000, unit: 'sf_hr',    visitsPerYear: 42, coveragePerVisit: 1.0, category: 'mtc', label: 'Litter Pickup' },
  sweeping:        { rate: 60000, unit: 'sf_hr',    visitsPerYear: 42, coveragePerVisit: 1.0, category: 'mtc', label: 'Sweeping' },
  trimming:        { rate: 12000, unit: 'sf_hr',    visitsPerYear: 12, coveragePerVisit: 1.0, category: 'mtc', label: 'Trimming / Hedging' },
  pruning:         { rate: 12,    unit: 'trees_or_sf_hr', visitsPerYear: 6, coveragePerVisit: 1.0, category: 'mtc', label: 'Low Pruning (< 8\')', sfRate: 10000 },
  deadheading:     { rate: 8000,  unit: 'sf_hr',    visitsPerYear: 12, coveragePerVisit: 1.0, category: 'mtc', label: 'Deadheading' },
  planting:        { rate: 4000,  unit: 'sf_hr',    visitsPerYear: 3,  coveragePerVisit: 1.0, category: 'mtc', label: 'Planting / Rotation' },

  // ── Arborist ──
  tree_trimming:   { rate: 4,     unit: 'trees_hr', visitsPerYear: 2,  coveragePerVisit: 1.0, category: 'arborist', label: 'Tree Trimming' },
  palm_trimming:   { rate: 3,     unit: 'trees_hr', visitsPerYear: 2,  coveragePerVisit: 1.0, category: 'arborist', label: 'Palm Trimming' },

  // ── Herbicide tech ──
  pre_emergent:    { rate: 65000, unit: 'sf_hr',    visitsPerYear: 2,  coveragePerVisit: 1.0, category: 'herbicide', label: 'Pre-Emergent' },
  fertilization:   { rate: 65000, unit: 'sf_hr',    visitsPerYear: 3,  coveragePerVisit: 1.0, category: 'herbicide', label: 'Fertilization' },
  pest_control:    { rate: 65000, unit: 'sf_hr',    visitsPerYear: 4,  coveragePerVisit: 1.0, category: 'herbicide', label: 'Pest Control' },

  // ── Irrigation tech ──
  irrigation_check:{ rate: 80000, unit: 'sf_hr',    visitsPerYear: 12, coveragePerVisit: 1.0, category: 'irrigation', label: 'Irrigation Check' },
};

export const RATE_UNIT_LABELS = {
  sf_hr: 'SF/hr',
  lf_hr: 'LF/hr',
  trees_hr: 'trees/hr',
  trees_or_sf_hr: 'trees/hr',
};

export const MODIFIER_MULTIPLIERS = {
  access_obstructed: 1.25,
  slope_sloped: 1.15,
  litterExposure_high: 1.2,
  weedPressure_med: 1.15,
  weedPressure_high: 1.35,
  limitedAccess: 1.3,
  blowRestrictions: 1.4,
};

// Default width in feet for polyline-drawn areas
export const DEFAULT_LINE_WIDTH = 4;

// Tree disposition types (show treeDetails editor)
export const TREE_TYPES = [
  AREA_TYPES.TREE_SALVAGE,
  AREA_TYPES.TREE_REMAIN,
  AREA_TYPES.TREE_REMOVE,
];

export const DEFAULT_TREE_DETAILS = {
  species: '',
  height: 0,
  caliper: 0,
  canopySpread: 0,
  condition: '',
};

export const TREE_CONDITION_OPTIONS = [
  { value: '', label: 'Not assessed' },
  { value: 'good', label: 'Good' },
  { value: 'fair', label: 'Fair' },
  { value: 'poor', label: 'Poor' },
  { value: 'dead', label: 'Dead' },
];

// Common AZ tree species for autocomplete suggestions
export const COMMON_TREE_SPECIES = [
  'Palo Brea',
  'Palo Verde - Blue',
  'Palo Verde - Foothills',
  'Palo Verde - Desert Museum',
  'Mesquite - Chilean',
  'Mesquite - Velvet',
  'Mesquite - Argentine',
  'Mesquite - Honey',
  'Ironwood',
  'Acacia - Sweet',
  'Acacia - Whitethorn',
  'Olive - Swan Hill',
  'Olive - Fruitless',
  'Sissoo',
  'Ficus - Indian Laurel',
  'Ficus - Nitida',
  'Pine - Aleppo',
  'Pine - Eldarica',
  'Eucalyptus',
  'Ash - Fan-Tex',
  'Ash - Raywood',
  'Ash - Arizona',
  'Palm - Date',
  'Palm - Fan',
  'Palm - Queen',
  'Palm - King',
  'Palm - Mexican Fan',
  'Vitex',
  'Tipu',
  'Jacaranda',
  'Bottle Tree',
  'Willow - Desert',
  'Willow - Goodding',
  'Citrus',
  'Texas Ebony',
  'Chaste Tree',
];

// ===== PLACEMENT QUEUE ITEM TYPES =====
// Each type defines: label, color, default areaType for placed points, and detail fields with labels
export const PLACEMENT_ITEM_TYPES = {
  tree: {
    label: 'Tree',
    color: '#228B22',
    defaultAreaType: AREA_TYPES.TREE_REMAIN,
    fields: [
      { key: 'species', label: 'Species', type: 'text' },
      { key: 'caliper', label: 'Caliper (in)', type: 'number' },
      { key: 'height', label: 'Height (ft)', type: 'number' },
      { key: 'canopySpread', label: 'Spread (ft)', type: 'number' },
      { key: 'condition', label: 'Condition', type: 'text' },
      { key: 'disposition', label: 'Disposition', type: 'text' },
    ],
    buildLabel: (d) => [d.species || d.commonName, d.caliper ? `${d.caliper}" cal` : '', d.height ? `${d.height}' ht` : ''].filter(Boolean).join(' — ') || 'Tree',
  },
  valve: {
    label: 'Irrigation Valve',
    color: '#2196F3',
    defaultAreaType: AREA_TYPES.POINT_MARKER,
    fields: [
      { key: 'zone', label: 'Zone', type: 'text' },
      { key: 'size', label: 'Size', type: 'text' },
      { key: 'valveType', label: 'Type', type: 'text' },
      { key: 'manufacturer', label: 'Manufacturer', type: 'text' },
      { key: 'gpm', label: 'GPM', type: 'number' },
    ],
    buildLabel: (d) => [d.zone ? `Zone ${d.zone}` : '', d.size, d.valveType].filter(Boolean).join(' — ') || 'Valve',
  },
  controller: {
    label: 'Controller',
    color: '#FF9800',
    defaultAreaType: AREA_TYPES.POINT_MARKER,
    fields: [
      { key: 'manufacturer', label: 'Manufacturer', type: 'text' },
      { key: 'model', label: 'Model', type: 'text' },
      { key: 'zones', label: 'Zones', type: 'number' },
      { key: 'locationDesc', label: 'Location', type: 'text' },
    ],
    buildLabel: (d) => [d.manufacturer, d.model, d.zones ? `${d.zones} zones` : ''].filter(Boolean).join(' — ') || 'Controller',
  },
  backflow: {
    label: 'Backflow',
    color: '#9C27B0',
    defaultAreaType: AREA_TYPES.POINT_MARKER,
    fields: [
      { key: 'backflowType', label: 'Type', type: 'text' },
      { key: 'size', label: 'Size', type: 'text' },
      { key: 'serial', label: 'Serial #', type: 'text' },
      { key: 'testDue', label: 'Test Due', type: 'text' },
    ],
    buildLabel: (d) => [d.backflowType, d.size, d.serial].filter(Boolean).join(' — ') || 'Backflow',
  },
  plant: {
    label: 'Plant Material',
    color: '#4CAF50',
    defaultAreaType: AREA_TYPES.POINT_MARKER,
    fields: [
      { key: 'species', label: 'Species', type: 'text' },
      { key: 'size', label: 'Size', type: 'text' },
      { key: 'qty', label: 'Qty', type: 'number' },
      { key: 'spacing', label: 'Spacing', type: 'text' },
      { key: 'container', label: 'Container', type: 'text' },
    ],
    buildLabel: (d) => [d.species, d.size, d.qty ? `x${d.qty}` : ''].filter(Boolean).join(' — ') || 'Plant',
  },
  boulder: {
    label: 'Boulder / Rock',
    color: '#8B7355',
    defaultAreaType: AREA_TYPES.POINT_MARKER,
    fields: [
      { key: 'material', label: 'Material', type: 'text' },
      { key: 'size', label: 'Size', type: 'text' },
      { key: 'qty', label: 'Qty', type: 'number' },
      { key: 'color', label: 'Color', type: 'text' },
      { key: 'notes', label: 'Notes', type: 'text' },
    ],
    buildLabel: (d) => [d.material, d.size, d.qty ? `x${d.qty}` : ''].filter(Boolean).join(' — ') || 'Boulder',
  },
};

// Get label for any areaType (handles legacy)
export const getAreaTypeLabel = (areaType) => {
  const resolved = resolveAreaType(areaType);
  return AREA_TYPE_LABELS[resolved] || areaType || 'Unknown';
};

// Get color for any areaType (handles legacy)
export const getAreaTypeColor = (areaType) => {
  const resolved = resolveAreaType(areaType);
  return AREA_TYPE_COLORS[resolved] || '#3388ff';
};
